module.exports = __webpack_public_path__ + "8eaf9afa0ef3f40543792c2586e6a087.MP3";